window.handleSuccessModal = function() {
  $("#recall-modal").modal('hide');
  $("#recall-modal-success").modal('show');
  $("#modal_question_question_phone").val("");
}